// extracted by mini-css-extract-plugin
module.exports = {"title":"ErrorTitle_title__MYU_d typography_h1__9vhsP"};